import { useColorModeValue } from "@chakra-ui/react";
import { FaDiscord, FaTelegramPlane } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const _t = (key?: string) => key || "";

const EventDetailContactUs = () => (
  <div
    className={`flex flex-row bg-white shadow-md py-4 sm:px-4 rounded-lg mt-8 items-center ${useColorModeValue(
      "",
      "bg-glass"
    )}`}
  >
    <div className="flex flex-col flex-grow justify-center items-start">
      <p className="text-base font-semibold mb-2 self-center dark:text-white">
        {_t("Facing technical issues ")}?
      </p>
      <div className="flex flex-row items-center self-center dark:text-white">
        <p className="text-sm mr-4 text-neutral dark:text-neutral-300">
          {_t("Contact us")}:
        </p>
        <div className="grid grid-cols-3 gap-4 text-primary text-2xl">
          <a href="mailto:support@moongate.id" target="_blank" rel="noreferrer">
            <MdEmail />
          </a>
          <a href="https://t.me/pweeh" target="_blank" rel="noreferrer">
            <FaTelegramPlane />
          </a>
          <a
            href="https://discord.com/channels/948159905494335488/948581449802608660"
            target="_blank"
            rel="noreferrer"
          >
            <FaDiscord />
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default EventDetailContactUs;
